import axios from "../../utilities/axios";

export const getTransactions = async (filter) => {
  const { limit, type, searchString, page } = filter;
  let queryString = "";
  if (limit) {
    queryString += `&_limit=${limit}`;
  }
  if (type) {
    queryString += `&type=${type}`;
  }
  if (searchString) {
    searchString.split(" ").forEach((query) => {
      queryString += `&name_like=${query}`;
    });
  }
  if (page) {
    queryString += `&_page=${page}`;
  }
  const response = await axios.get(`/transactions?_sort=id&_order=desc${queryString}`);

  return { data: response.data, totalData: Number(response.headers["x-total-count"]) };
};

export const addTransaction = async (data) => {
  const response = await axios.post("/transactions", data);
  return response.data;
};
export const getBalance = async () => {
  const response = await axios.get("/transactions");
  return response.data;
};

export const editTransaction = async (id, data) => {
  const response = await axios.put(`/transactions/${id}`, data);
  return response.data;
};

export const deleteTransaction = async (id) => {
  await axios.delete(`/transactions/${id}`);
  return id;
};
